import React, { useEffect } from 'react';
import { getWindow } from 'ssr-window';
import WalkingDistanceDisplay from 'common/spot-details/walking-distance';
import { useGoogleMapsLibraries } from 'common/google-map-context/GoogleMapContext';
const window = getWindow();
const SpotDetailsDirectionsMap = (props) => {
    const mapRef = React.useRef(null);
    const googleMapRef = React.useRef(null);
    const boundsRef = React.useRef(null);
    const { googleMapsLoaded, googleMapsLibraries } = useGoogleMapsLibraries();
    const onWindowResize = () => {
        if (googleMapRef.current && boundsRef.current) {
            googleMapRef.current.fitBounds(boundsRef.current);
        }
    };
    useEffect(() => {
        if (googleMapRef.current === null && googleMapsLoaded) {
            const { isDraggable, disableDefaultUI, onClick, isDriving, spotLatitude, spotLongitude, destinationLatitude, destinationLongitude, } = props;
            const iconSize = 32;
            // const gmaps = googleMaps || window.google.maps;
            const iconBasePath = `https://res.cloudinary.com/spothero/image/upload/c_fill,dpr_2.0,w_${iconSize}/v1579014835/google-assistant`;
            const directionsService = new googleMapsLibraries.routes.DirectionsService();
            const directionsDisplay = new googleMapsLibraries.routes.DirectionsRenderer({
                polylineOptions: {
                    icons: isDriving
                        ? null
                        : [
                            {
                                icon: {
                                    path: googleMapsLibraries.core
                                        .SymbolPath.CIRCLE,
                                    fillOpacity: 1,
                                    scale: 3,
                                },
                                repeat: '12px',
                            },
                        ],
                    strokeColor: '#0082ff',
                    strokeOpacity: isDriving ? 1 : 0,
                    strokeWeight: 2,
                },
                suppressMarkers: true,
            });
            const spotLatLng = { lat: spotLatitude, lng: spotLongitude };
            const destinationLatLng = {
                lat: destinationLatitude,
                lng: destinationLongitude,
            };
            boundsRef.current = new googleMapsLibraries.core.LatLngBounds();
            boundsRef.current.extend(spotLatLng);
            boundsRef.current.extend(destinationLatLng);
            const mapOptions = {
                zoom: 17,
                center: destinationLatLng,
                mapTypeId: googleMapsLibraries.maps.MapTypeId.ROADMAP,
                gestureHandling: isDraggable ? 'auto' : 'none',
                keyboardShortcuts: isDraggable,
                clickableIcons: false,
            };
            if (disableDefaultUI) {
                mapOptions.disableDefaultUI = true;
            }
            else {
                mapOptions.mapTypeControl = false;
                mapOptions.fullscreenControl = false;
            }
            googleMapRef.current = new googleMapsLibraries.maps.Map(mapRef.current, mapOptions);
            // eslint-disable-next-line no-new
            new googleMapsLibraries.marker.Marker({
                map: googleMapRef.current,
                position: spotLatLng,
                icon: {
                    url: `${iconBasePath}/parking-pin.png`,
                    scaledSize: new googleMapsLibraries.core.Size(iconSize, iconSize),
                },
            });
            // eslint-disable-next-line no-new
            new googleMapsLibraries.marker.Marker({
                map: googleMapRef.current,
                position: destinationLatLng,
                icon: {
                    url: `${iconBasePath}/map-pin.png`,
                    scaledSize: new googleMapsLibraries.core.Size(iconSize, iconSize),
                },
            });
            if (onClick) {
                googleMapRef.current.addListener('click', onClick);
            }
            window.addEventListener('resize', onWindowResize);
            googleMapRef.current.fitBounds(boundsRef.current);
            directionsService.route({
                origin: spotLatLng,
                destination: destinationLatLng,
                travelMode: props.isDriving
                    ? googleMapsLibraries.routes.TravelMode.DRIVING
                    : googleMapsLibraries.routes.TravelMode.WALKING,
            }, (result, status) => {
                if (status === 'OK') {
                    directionsDisplay.setMap(googleMapRef.current);
                    directionsDisplay.setDirections(result);
                    setTimeout(() => {
                        googleMapRef.current.fitBounds(boundsRef.current);
                    }, 200);
                }
            });
        }
        return () => {
            window.removeEventListener('resize', onWindowResize);
            if (googleMapRef.current) {
                google.maps.event.clearInstanceListeners(googleMapRef.current);
            }
        };
    }, [props, googleMapsLoaded, googleMapsLibraries]);
    if (typeof window === 'undefined' || !googleMapsLoaded) {
        return null;
    }
    const { isDriving, linearMeters, walkingMeters, walkingDuration } = props;
    return (<div className="SpotDetailsDirectionsMap">
            <div ref={mapRef} className="SpotDetailsDirectionsMap-container"/>
            {!isDriving && (<WalkingDistanceDisplay linearMeters={linearMeters} walkingMeters={walkingMeters} walkingDuration={walkingDuration}/>)}
        </div>);
};
export default SpotDetailsDirectionsMap;
